import { render } from "./Pcp.vue?vue&type=template&id=464872e0"
import script from "./Pcp.vue?vue&type=script&lang=js"
export * from "./Pcp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__